<template>
  <div id="printable" class="register-container">
    <!-- Header -->
    <div class="header">
      <div class="facility-name">
        TUURU COTTOLENGO HEALTH CENTRE - AR2026259
      </div>
      <div class="facility-details">
        <div>Igembe Central</div>
        <div>P.O BOX 77 - Meru | Tel: 254254746758069</div>
        <div>Email: suore.tuuru@cottolengo.org</div>
      </div>
      <div class="register-title">
        MOH 204B - OUTPATIENT REGISTER (Over five years)
      </div>
    </div>

    <!-- Date Filter and Print Toolbar -->
    <div class="toolbar">
      <div class="date-filters">
        <div class="filter-group">
          <label>From Date:</label>
          <input
            type="date"
            v-model="dateFrom"
            class="date-input"
            @change="filterPatients"
          />
        </div>
        <div class="filter-group">
          <label>To Date:</label>
          <input
            type="date"
            v-model="dateTo"
            class="date-input"
            @change="filterPatients"
          />
        </div>
        <button @click="clearDates" class="btn-clear">Clear</button>
      </div>
      <button @click="printPage" class="btn-print">🖨️ Print Register</button>
    </div>

    <!-- Date Range Display (visible on print) -->
    <div class="date-range-print" v-if="dateFrom || dateTo">
      <strong>Report Period:</strong>
      {{ dateFrom || "Start" }} to {{ dateTo || "End" }}
    </div>
    <div class="date-range-print" v-else>
      <strong>Report Period:</strong> All Records
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <table class="register-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Date</th>
            <th>ODP No</th>
            <th>Re-visit</th>
            <th>Full Names</th>
            <th>Age(yrs)</th>
            <th>Sex</th>
            <th>Contact</th>
            <th>SubLocation</th>
            <th>Weight(kg)</th>
            <th>Height(cm)</th>
            <th>BMI (Kg/m²)</th>
            <th>Temp(°C)</th>
            <th>BP</th>
            <th>TB Screening</th>
            <th>Visual Acuity</th>
            <th>HIV(1=counselled,2=tested)</th>
            <th>HIV(Pos/Neg)</th>
            <th>Nutrition interventions</th>
            <th>Diagnosis</th>
            <th>Malaria</th>
            <th>Treatment/prescription</th>
            <th>Amount charged</th>
            <th>Referral</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(patient, index) in filteredPatients" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ patient.date }}</td>
            <td>{{ patient.odpNo }}</td>
            <td>{{ patient.revisit }}</td>
            <td>{{ patient.fullNames }}</td>
            <td>{{ patient.age }}</td>
            <td>{{ patient.sex }}</td>
            <td>{{ patient.contact }}</td>
            <td>{{ patient.subLocation }}</td>
            <td>{{ patient.weight }}</td>
            <td>{{ patient.height }}</td>
            <td>{{ patient.bmi }}</td>
            <td>{{ patient.temp }}</td>
            <td>{{ patient.bp }}</td>
            <td>{{ patient.tbScreening }}</td>
            <td>{{ patient.visualAcuity }}</td>
            <td>{{ patient.hivStatus }}</td>
            <td>{{ patient.hivResult }}</td>
            <td>{{ patient.nutrition }}</td>
            <td>{{ patient.diagnosis }}</td>
            <td>{{ patient.malaria }}</td>
            <td>{{ patient.treatment }}</td>
            <td>{{ patient.amountCharged }}</td>
            <td>{{ patient.referral }}</td>
            <td>{{ patient.remarks }}</td>
          </tr>
          <tr v-if="filteredPatients.length === 0">
            <td colspan="25" class="empty-row">
              No records found for the selected date range
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "OutpatientRegister",
  data() {
    return {
      dateFrom: "",
      dateTo: "",
      patients: [
        {
          date: "2024-01-15",
          odpNo: "001",
          revisit: "New",
          fullNames: "John Mwenda",
          age: 32,
          sex: "M",
          contact: "0712345678",
          subLocation: "Kianjai",
          weight: "68",
          height: "175",
          bmi: "22.2",
          temp: "36.5",
          bp: "120/80",
          tbScreening: "Negative",
          visualAcuity: "20/20",
          hivStatus: "2",
          hivResult: "Neg",
          nutrition: "2",
          diagnosis: "URTI",
          malaria: "Negative",
          treatment: "Paracetamol 500mg",
          amountCharged: "500",
          referral: "",
          remarks: "Improved",
        },
        {
          date: "2024-01-20",
          odpNo: "002",
          revisit: "Re-visit",
          fullNames: "Mary Wanjiku",
          age: 45,
          sex: "F",
          contact: "0723456789",
          subLocation: "Mutuati",
          weight: "72",
          height: "162",
          bmi: "27.4",
          temp: "37.2",
          bp: "130/85",
          tbScreening: "Negative",
          visualAcuity: "20/25",
          hivStatus: "1",
          hivResult: "",
          nutrition: "1",
          diagnosis: "Hypertension",
          malaria: "Not Tested",
          treatment: "Lisinopril 10mg",
          amountCharged: "800",
          referral: "",
          remarks: "Review in 2 weeks",
        },
        {
          date: "2024-02-05",
          odpNo: "003",
          revisit: "New",
          fullNames: "Peter Kimathi",
          age: 28,
          sex: "M",
          contact: "0734567890",
          subLocation: "Kangeta",
          weight: "65",
          height: "170",
          bmi: "22.5",
          temp: "36.8",
          bp: "118/75",
          tbScreening: "Negative",
          visualAcuity: "20/20",
          hivStatus: "2",
          hivResult: "Neg",
          nutrition: "2",
          diagnosis: "Malaria",
          malaria: "Positive",
          treatment: "Coartem",
          amountCharged: "400",
          referral: "",
          remarks: "Fever reduced",
        },
        {
          date: "2024-02-10",
          odpNo: "004",
          revisit: "New",
          fullNames: "Grace Muthoni",
          age: 34,
          sex: "F",
          contact: "0745678901",
          subLocation: "Laare",
          weight: "58",
          height: "160",
          bmi: "22.7",
          temp: "37.0",
          bp: "110/70",
          tbScreening: "Negative",
          visualAcuity: "20/20",
          hivStatus: "1",
          hivResult: "",
          nutrition: "1",
          diagnosis: "UTI",
          malaria: "Negative",
          treatment: "Ciprofloxacin",
          amountCharged: "600",
          referral: "",
          remarks: "Drink plenty water",
        },
        {
          date: "2024-03-01",
          odpNo: "005",
          revisit: "Re-visit",
          fullNames: "James Mwirigi",
          age: 52,
          sex: "M",
          contact: "0756789012",
          subLocation: "Kianjai",
          weight: "85",
          height: "168",
          bmi: "30.1",
          temp: "36.6",
          bp: "145/95",
          tbScreening: "Negative",
          visualAcuity: "20/30",
          hivStatus: "2",
          hivResult: "Neg",
          nutrition: "3",
          diagnosis: "Diabetes Type 2",
          malaria: "Not Tested",
          treatment: "Metformin 500mg",
          amountCharged: "1000",
          referral: "Refer to Meru Level 5",
          remarks: "Diet review needed",
        },
      ],
    };
  },
  computed: {
    filteredPatients() {
      if (!this.dateFrom && !this.dateTo) {
        return this.patients;
      }

      return this.patients.filter((patient) => {
        const patientDate = patient.date;
        if (this.dateFrom && this.dateTo) {
          return patientDate >= this.dateFrom && patientDate <= this.dateTo;
        } else if (this.dateFrom) {
          return patientDate >= this.dateFrom;
        } else if (this.dateTo) {
          return patientDate <= this.dateTo;
        }
        return true;
      });
    },
  },
  methods: {
    filterPatients() {
      // This method is triggered by @change on date inputs
      // The computed property will automatically update
    },
    clearDates() {
      this.dateFrom = "";
      this.dateTo = "";
    },
    printPage() {
      window.print();
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.register-container {
  background: white;
  min-height: 100vh;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

/* Header */
.header {
  text-align: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #1a56db;
}

.facility-name {
  font-size: 22px;
  font-weight: bold;
  color: #1a56db;
  margin-bottom: 8px;
}

.facility-details {
  font-size: 12px;
  color: #4b5563;
  line-height: 1.5;
  margin-bottom: 12px;
}

.register-title {
  font-size: 16px;
  font-weight: bold;
  background: #f3f4f6;
  display: inline-block;
  padding: 6px 20px;
  border-radius: 20px;
  color: #1f2937;
}

/* Toolbar */
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.date-filters {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-group label {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}

.date-input {
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 13px;
  font-family: inherit;
}

.btn-clear {
  padding: 8px 16px;
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-clear:hover {
  background: #4b5563;
}

.btn-print {
  padding: 8px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-print:hover {
  background: #2563eb;
}

/* Date Range Print Display */
.date-range-print {
  text-align: center;
  padding: 10px;
  margin-bottom: 16px;
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  font-size: 13px;
  color: #92400e;
  border-radius: 6px;
}

/* Table Wrapper */
.table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}

.register-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  min-width: 1800px;
}

.register-table th {
  background: #1f2937;
  color: white;
  padding: 10px 6px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #374151;
  position: sticky;
  top: 0;
}

.register-table td {
  border: 1px solid #d1d5db;
  padding: 8px 6px;
  text-align: center;
  background: white;
}

.empty-row {
  text-align: center;
  padding: 30px;
  color: #6b7280;
  font-size: 13px;
}

/* ============================================ */
/* PRINT STYLES - Ensures everything fits on page */
/* ============================================ */
@media print {
  @page {
    size: landscape;
    margin: 0.5cm;
  }

  body {
    margin: 0;
    padding: 0;
  }

  .toolbar {
    display: none;
  }

  .register-container {
    padding: 0.3cm;
    margin: 0;
    width: 100%;
  }

  .date-range-print {
    background: #fef3c7;
    border: 1px solid #ccc;
    margin: 5px 0 10px 0;
    padding: 5px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .table-wrapper {
    overflow: visible !important;
    border: none;
  }

  .register-table {
    width: 100%;
    min-width: 0 !important;
    font-size: 7px !important;
    table-layout: auto !important;
    border-collapse: collapse;
  }

  .register-table th {
    background: #e5e7eb !important;
    color: black !important;
    padding: 4px 2px !important;
    font-size: 7px !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .register-table td {
    padding: 3px 2px !important;
    font-size: 6.5px !important;
    border: 0.5px solid #ccc;
  }

  .header {
    margin-bottom: 5px;
    padding-bottom: 5px;
  }

  .facility-name {
    font-size: 14px;
  }

  .facility-details {
    font-size: 8px;
  }

  .register-title {
    font-size: 10px;
    padding: 2px 10px;
  }
}
</style>
